import VehicleCarousel from './VehicleCarousel'

export default VehicleCarousel